import Vue from 'vue'
import VImageInput from 'vuetify-image-input'
Vue.component('VImageInput', VImageInput)
